import fetchWebApi from 'api/fetchWebApi';

export interface GetFdfResponse {
  fastDeliveryFee: number;
}

const getFdfApiCall = async (): Promise<GetFdfResponse> =>
  fetchWebApi('/client/fdf');

export default getFdfApiCall;
